import React from 'react';

const useLoading = (): { isLoading: boolean; handleLoading: (status?: boolean) => void } => {
    const [isLoading, setIsLoading] = React.useState(false);

    const handleLoading = (status = false) => {
        setIsLoading(status);
    };

    return { isLoading, handleLoading };
};

export default useLoading;
